import React from 'react';
import { mockChargingStations } from '../../../mocks/demoEdgeMockChargers';
import { demoEdgeMockPlazaDetails } from '../../../mocks/demoEdgeMockPlazaDetails';
import './_styles.scss';
import { Dialog, CloseDialogAction } from '../../../../../common/components/Dialog/Dialog';
import InfoItem from '../../../../../common/components/InfoItem/InfoItem';
import DemoEdgeStatusBadge from '../../components/DemoEdgeStatusBadge/DemoEdgeStatusBadge';

const DemoEdgePlazaDetailsDialog = ({ open, onClose, plazaId = null, plazaName = null, edgeControllerId = null }) => {
  if (!plazaId) return null;

  const plazaDetails = demoEdgeMockPlazaDetails[plazaId] || {};
  const chargingStations = mockChargingStations[plazaId] || [];

  const getStatusClassName = (status) => {
    const statusMap = {
      NOT_CONNECTED: 'status-available',
      CONNECTED_CHARGING: 'status-charging',
      FAULTED: 'status-faulted',
      CONNECTED_NOT_CHARGING: 'status-available',
      UNKNOWN: 'status-unknown',
      RESERVED_CABLE_DISCONNECTED: 'status-available',
    };
    return statusMap[status] || 'status-unknown';
  };

  const getStatusLabel = (status) => {
    const labelMap = {
      NOT_CONNECTED: 'Cable Disconnected',
      CONNECTED_CHARGING: 'Charging',
      FAULTED: 'Faulted',
      CONNECTED_NOT_CHARGING: 'Cable Connected, Not Charging',
      UNKNOWN: 'Unknown',
      RESERVED_CABLE_DISCONNECTED: 'Cable Disconnected, Reserved',
    };
    return labelMap[status] || status;
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      title={`Plaza Details: ${plazaName}`}
      maxWidth="md"
      fullWidth
      actions={<CloseDialogAction onClose={onClose} />}
      className="plaza-details-dialog"
    >
      <div className="plaza-details-content">
        <div className="plaza-info-section">
          <h3>Plaza Information</h3>
          <div className="info-grid">
            <InfoItem label="Address" value={plazaDetails.address} />
            <InfoItem label="Total Chargers" value={plazaDetails.totalChargers ?? 0} />
            <InfoItem label="Available Chargers" value={plazaDetails.availableChargers ?? 0} />
            <InfoItem label="Plaza Algorithm" value={plazaDetails.algorithm} />
            <InfoItem label="Edge Controller" value={edgeControllerId} />
          </div>
        </div>

        <div className="charging-stations-section">
          <h3>Charging Stations Managed by this Edge Controller</h3>
          {chargingStations.length > 0 ? (
            <div className="charging-stations-table">
              <table>
                <thead>
                  <tr>
                    <th>Charger ID</th>
                    <th>Name</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  {chargingStations.map((station) => (
                    <tr key={station.id}>
                      <td>{station.id}</td>
                      <td>{station.name}</td>
                      <td aria-label={`Status: ${getStatusLabel(station.status)}`}>
                        <DemoEdgeStatusBadge status={getStatusLabel(station.status)} statusClassName={getStatusClassName(station.status)} />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : (
            <p className="no-stations-message">No charging stations assigned to this plaza.</p>
          )}
        </div>
      </div>
    </Dialog>
  );
};

export default DemoEdgePlazaDetailsDialog;
